import { QUERY_READMODEL_REQUEST, QUERY_READMODEL_SUCCESS, QUERY_READMODEL_FAILURE, DROP_READMODEL_STATE, CONNECT_READMODEL, DISCONNECT_READMODEL } from '../internal/action-types';
export var queryReadModelRequest = function queryReadModelRequest(query, initialState, selectorId) {
  return {
    type: QUERY_READMODEL_REQUEST,
    query: query,
    initialState: initialState,
    selectorId: selectorId
  };
};
export var queryReadModelSuccess = function queryReadModelSuccess(query, result, selectorId) {
  return {
    type: QUERY_READMODEL_SUCCESS,
    query: query,
    result: result,
    selectorId: selectorId
  };
};
export var queryReadModelFailure = function queryReadModelFailure(query, error, selectorId) {
  return {
    type: QUERY_READMODEL_FAILURE,
    query: query,
    error: error,
    selectorId: selectorId
  };
};
export var dropReadModelResult = function dropReadModelResult(query, selectorId) {
  return {
    type: DROP_READMODEL_STATE,
    query: query,
    selectorId: selectorId
  };
};
export var connectReadModel = function connectReadModel(query, skipConnectionManager) {
  return {
    type: CONNECT_READMODEL,
    query: query,
    skipConnectionManager: skipConnectionManager
  };
};
export var disconnectReadModel = function disconnectReadModel(query) {
  return {
    type: DISCONNECT_READMODEL,
    query: query
  };
};
//# sourceMappingURL=actions.js.map